"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineSupportedVideoPlatforms = void 0;
const detectrtc_1 = __importDefault(require("detectrtc"));
const api_1 = require("@streem/api");
const logger_1 = require("./logger");
function determineSupportedVideoPlatforms() {
    const supportedPlatforms = [
        api_1.StreemApiDeviceSupportedVideoPlatforms.TWILIO,
        api_1.StreemApiDeviceSupportedVideoPlatforms.ARAAS,
        api_1.StreemApiDeviceSupportedVideoPlatforms.CHIME,
    ];
    // https://github.com/muaz-khan/DetectRTC/blob/master/DetectRTC.js#L879-L890
    if (!detectrtc_1.default.isWebRTCSupported) {
        logger_1.logger.warn('User is on a browser that does not support WebRTC: ', detectrtc_1.default.browser.fullVersion);
    }
    return supportedPlatforms;
}
exports.determineSupportedVideoPlatforms = determineSupportedVideoPlatforms;
//# sourceMappingURL=determine_supported_video_platforms.js.map